import React, { createContext, useContext } from "react";

const RADEventContext = createContext();

export const RADEventProvider = ({ children, onClick, onBackgroundClick }) => {
  const contextValue = {
    onClick,
    onBackgroundClick,
  };

  return (
    <RADEventContext.Provider value={contextValue}>
      {children}
    </RADEventContext.Provider>
  );
};

export const useRADEvents = () => {
  const context = useContext(RADEventContext);
  if (!context) {
    throw new Error("useRADEvents must be used within a RADEventProvider");
  }
  return context;
};
